import { ApolloError, useMutation } from "@apollo/client";
import { loader } from "graphql.macro";
import { Fragment, ReactElement, ReactNode } from "react";

import {
  RenderProjectMutation as RenderProjectMutationType,
  RenderProjectMutationVariables,
} from "./__generated__/RenderProjectMutation";

const RenderProjectMutation = loader("./RenderProjectMutation.gql");

type RenderProjectMutationProviderType = (props: {
  children: (loading: boolean, mutate: any) => ReactNode;
  onError?: (error: ApolloError) => void;
  onCompleted: (data: RenderProjectMutationType) => void;
}) => ReactElement;

export const RenderProjectMutationProvider: RenderProjectMutationProviderType = (props) => {
  const { children, onError, onCompleted } = props;

  const [mutate, { loading }] = useMutation<RenderProjectMutationType, RenderProjectMutationVariables>(
    RenderProjectMutation,
    {
      errorPolicy: "none",
      onError,
      onCompleted,
    },
  );

  return <Fragment>{children(loading, mutate)}</Fragment>;
};
